<script>
  import NodeEditor from '../dataset/NodeEditor.svelte';
  import LinkEditor from '../dataset/LinkEditor.svelte';
  import RawDatasetEditor from '../dataset/RawDatasetEditor.svelte';
  import NodePropsConnectionEditor from '../dataset/NodePropsConnectionEditor.svelte';
  import { getRelationTypeFromDataset } from '../../../stores/questionsetStore';
  
  export let question;
  export let updateWorkingQuestion;
  export let hasUnsavedChanges;
  export let questionIndex;
  
  // Reactive derived state - automatically updates when question changes
  $: relationshipType = getRelationTypeFromDataset(question.dataset, question);
  $: hasNodes = question.dataset?.some(handler => handler[0] === 'nodes' || handler[0] === 'setSelf');
  $: hasLinks = question.dataset?.some(handler => handler[0] === 'links');
  $: hasNodeProps = question.dataset?.some(handler => handler[0] === 'nodeProps');
  
  // Helper function to ensure hasUnsavedChanges is updated consistently
  function handleUpdate(field, value) {
    updateWorkingQuestion(field, value);
    hasUnsavedChanges = true;
  }
</script>

<div class="edit-section">
  <div class="form-styled">
    {#if hasNodes}
      <NodeEditor 
        question={question}
        updateWorkingQuestion={handleUpdate}
      />
    {/if}
    
    {#if hasLinks}
      <LinkEditor 
        question={question}
        updateWorkingQuestion={handleUpdate}
        {questionIndex}
      />
    {/if}

    {#if hasNodeProps}
      <NodePropsConnectionEditor 
        question={question}
        updateWorkingQuestion={handleUpdate}
      />
    {/if}
    
    <RawDatasetEditor
      question={question}
      updateWorkingQuestion={handleUpdate}
    />
  </div>
</div>

<style lang="scss">
  .edit-section {
    border: 4px solid #d4d3bc;
    border-radius: 0;
    padding: 15px;
    margin-bottom: 20px;
    background: #f3f2e3;
  }
  
  .form-styled {
    display: flex;
    flex-direction: column;
    gap: 0;
  }
</style>